module.exports = __webpack_public_path__ + "userfiles/yoli/img/phone.2009b8aa.png";